import "./OnceOfHouseCleaning.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SEO from "../SEO/SEO";
import heroImage from "../Assets/Services/Adelaide-banner-img.png";
import onceOffImg from "../Assets/HouseCleaning/Once-off-Cleaning.png";
import regularCleaningImg from "../Assets/HouseCleaning/Regular-house-cleaning.png";
import leaseCleaningImg from "../Assets/HouseCleaning/End-of-Lease-Cleaning.png";
import getaquote from "../Assets/get_a_quote.jpg";
import { Link } from "react-router-dom";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import React, { useState, useEffect, useRef } from "react";
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import trueicon from "../Assets/HouseCleaning/true-icon.png";
import SubFaqPage from "../SubServices/SubFaqPage";
import SuburbsSection from "../Services/SuburbsSection";

const OfficeCleaning = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const [item, setItem] = useState(null);

  useEffect(() => {
    api.get(`/whychoosehousecleaningservice/view/15`).then((res) => {
      setItem(res.data);
    });
  }, []);

  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/sub-services-after-hero/5") // change ID if needed
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  }, []);
  // Fetch slider content from API
  const [sliderData, setSliderData] = useState({
    headline: "Office Cleaning Services",
    subtext: "",
  });

  useEffect(() => {
    api
      .get("service-slider/office-cleaning")
      .then((res) => {
        if (res.data) {
          setSliderData({
            headline: res.data.headline,
            subtext: res.data.subtext,
          });
        }
      })
      .catch((err) => console.error("Slider Fetch Error", err));
  }, []);

  return (
    <>
      <SEO />
      <Header />

      <section
        className="hero-section py-5 text-white text-center"
        style={{
          background: `url(${heroImage}) center/cover`,
        }}
      >
        <div className="container" style={{ marginTop: "100px" }}>
          <h1 className="display-5 fw-bold">{sliderData.headline || "Office Cleaning Services"}</h1>

          {sliderData.subtext && (
            <p className="lead mb-4 px-4" style={{ maxWidth: "800px", margin: "0 auto 20px" }}>
              {sliderData.subtext}
            </p>
          )}

          <span>
            Home
            <Link
              to="/service/commercial-cleaning/"
              className="text-decoration-none text-white"
            >
              / Services
            </Link>
          </span>

          <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
            <Link
              to="/free-quote"
              className="btn btn-danger d-inline-flex align-items-center gap-2"
            >
              Get Free Quote <FaArrowRight />
            </Link>
            <Link
              to="tel:0406958557"
              className="btn btn-primary d-inline-flex align-items-center gap-2"
            >
              Call Now <FaPhoneAlt />
            </Link>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center gy-5">
            {/* Image Section */}
            <div className="col-lg-6">
              <div className="position-relative overflow-hidden rounded-4 shadow blog-img-wrapper">
                <img
                  src={`${PUBLIC_BASE_URL}${data?.image}`}
                  alt={data?.heading}
                  className="img-fluid w-100 rounded-4 object-fit-cover"
                  style={{ minHeight: "300px" }}
                />
              </div>
            </div>

            {/* Content Section */}
            <div className="col-lg-6">
              <div className="p-4 bg-white bg-opacity-75 shadow-lg rounded-4 animate-fade">
                <h2 className="fw-bold mb-3" style={{ color: "#001070" }}>
                  {data?.heading}
                </h2>
                {data?.description.split("\n").map((line, idx) => (
                  <p key={idx} className="text" style={{ color: "#2B2B2B" }}>
                    {line}
                  </p>
                ))}
                <div className="d-flex gap-3 mt-4 flex-wrap">
                  <Link
                    to="/free-quote"
                    className="btn btn-danger px-4 py-2 fw-semibold"
                  >
                    Get Free Quote
                  </Link>
                  <Link
                    to="/contact-us"
                    className="btn btn-primary px-4 py-2 fw-semibold"
                  >
                    Call Now <i className="bi bi-telephone-fill"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-options">
        <div className="container">
          <h2>Why Invest in Office house cleaning? </h2>

          <div className="services-grid">
            {/* Card 1 */}
            <div className="service-card">
              <i>
                <img
                  src={onceOffImg}
                  alt="Once-off-Cleaning"
                  style={{ width: "60px" }}
                />
              </i>
              <h3>Enhanced Productivity</h3>
              <p>
                A clean and organized office environment promotes productivity
                by reducing distractions and creating a more pleasant workspace
                for employees. Shiny cleaning provides clutter-free desks,
                sanitized surfaces, and fresh air, employees can focus better on
                their tasks.
              </p>
            </div>

            {/* Card 2 */}
            <div className="service-card">
              <i>
                <img
                  src={regularCleaningImg}
                  alt="Regular-house-cleaning"
                  style={{ width: "60px" }}
                />
              </i>
              <h3>Healthier Work Environment</h3>
              <p>
                Regular office cleaning helps reduce the spread of germs,
                bacteria, and allergens, creating a healthier work environment
                for employees. This can lead to fewer sick days, lower
                absenteeism rates, and higher overall employee well-being.
              </p>
            </div>

            {/* Card 3 */}
            <div className="service-card">
              <i>
                <img
                  src={leaseCleaningImg}
                  alt="End-of-Lease-Cleaning"
                  style={{ width: "60px" }}
                />
              </i>
              <h3>Positive First Impressions</h3>
              <p>
                A clean and tidy office creates a positive first impression on
                clients, visitors, and potential business partners. A
                professional-looking workspace reflects positively on the
                company's image and reputation, instilling confidence, and trust
                in clients.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose py-5">
        <div className="why-container container d-flex flex-column flex-lg-row align-items-center justify-content-between">
          <div className="why-text mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4">
              {item?.heading.split(" ").slice(0, -3).join(" ")}{" "}
              <span>{item?.heading.split(" ").slice(-3).join(" ")}</span>
            </h2>
            <ul className="list-unstyled">
              {item?.points.map((point, index) => (
                <li className="mb-3 d-flex align-items-start" key={index}>
                  <img src={trueicon} alt="check" className="me-2 icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="why-image text-center">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.before_image}`}
                  alt="Before"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">Before</div>
              </div>

              <div className="fw-bold display-5 mx-2 d-none d-md-block">→</div>

              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.after_image}`}
                  alt="After"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">After</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFaqPage id="Office Cleaning Services" />

      <SuburbsSection />

      <section className="quote-section pt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="quote-container container text-center">
              <h2 className=" fw-bold mb-3">Book Reliable Office Cleaning Services!</h2>
              <p className="mb-4 text-muted mt-5">
               From small offices to corporate spaces, Shiny Cleaning delivers dependable, spotless commercial cleaning services in Adelaide & Melbourne .
Book your quote today and experience the difference in professional office care.

              </p>

              <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
                <Link
                  to="/free-quote"
                  className="btn btn-outline-info d-inline-flex align-items-center gap-2 "
                >
                  Get Free Quote <FaArrowRight />
                </Link>
                <Link
                  to="tel:0406958557"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                >
                  Call Now <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-5">
            <img src={getaquote} className="h-75 w-75" />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default OfficeCleaning;
